import asyncComponent from '../common/utils/async-component';

const Webhooks = asyncComponent(() => import('./components/webhooks'));

export default {
  '/webhooks': {
    components: { main: Webhooks }
  }
};
